module.exports = require('./helpers/bundle-url').getBundleURL('7VwIV') + "trello-right.e6e102c7.svg";